(() => {
  let observer;
  let pending = false;
  const update = () => {
    pending = false;
    const header = document.querySelector('store-header');
    if (!header) return;
    const menuOpen = matchMedia('(max-width: 768px)').matches && header.querySelector('.main-menu__disclosure[open]');
    const searchOpen = !header.classList.contains('search-is-collapsed');
    header.classList.toggle('gm-header-solid', scrollY > 64 || !!menuOpen || searchOpen || header.classList.contains('gm-category-open'));
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  const init = () => {
    observer?.disconnect();
    const header = document.querySelector('store-header');
    if (!header) return;
    observer = new MutationObserver(schedule);
    observer.observe(header, { attributes: true, attributeFilter: ['class', 'open'], subtree: true });
    update();
  };
  document.addEventListener('gm:category-change', update);
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', init);
  init();
})();

// Keep copy clear of the card when product names wrap or fonts finish loading.
(() => {
  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ target }) => target.closest('.gm-fullscreen-slide')?.style.setProperty('--gm-product-height', `${target.offsetHeight}px`));
  });
  const observeCards = () => {
    observer.disconnect();
    document.querySelectorAll('.gm-hero-product').forEach((card) => observer.observe(card));
  };
  observeCards();
  document.addEventListener('shopify:section:load', observeCards);
})();
